import React from "react";
import { Form } from "components";

export function Filters({ filters, onChange, onClean }) {
  return (
    <Form>
      <div className="row">
        <Form.Field className="col-md-4">
          <Form.Label>CPF</Form.Label>
          <Form.Input
            placeholder="123.123.123-12"
            value={filters.cpf}
            onChange={(event) => onChange("cpf", event.target.value)}
          />
        </Form.Field>
        <Form.Field className="col-md-3">
          <Form.Label>Período, de</Form.Label>
          <Form.DatePicker
            dateFormat="dd/MM/yyyy"
            selected={filters.startAt}
            onChange={(value) => onChange("startAt", value)}
            minDate={new Date(2024, 4, 1)}
          />
        </Form.Field>
        <Form.Field className="col-md-3">
          <Form.Label>Período, até</Form.Label>
          <Form.DatePicker
            dateFormat="dd/MM/yyyy"
            selected={filters.endAt}
            onChange={(value) => onChange("endAt", value)}
            minDate={filters.startAt}
            maxDate={new Date()}
            disabled={!filters.startAt}
          />
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Label>Mês de referência</Form.Label>
          <Form.DatePicker
            showMonthYearPicker
            dateFormat="MM/yyyy"
            selected={filters.cashbackReferenceMonth}
            onChange={(value) => onChange("cashbackReferenceMonth", value)}
            minDate={new Date(2024, 4, 1)}
            maxDate={new Date()}
          />
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Button className="button-clean-filter" onClick={onClean}>
            Resetar filtros
          </Form.Button>
        </Form.Field>
      </div>
    </Form>
  );
}
